class StudyApi {
    fetchService;
    baseUrl = '/study';
    constructor(fetchService) {
        this.fetchService = fetchService;
    }
    getStudy(studyId) {
        return this.fetchService.get(`${this.baseUrl}/${studyId}`);
    }
}
export default StudyApi;
